// Update a page's lastmod only when its indexable content changes materially.
const SEO_LANDING_PAGES = [
  {
    path: '/transcriure-audio-a-text',
    primaryKeyword: 'transcriure àudio a text',
    title: "Transcriure àudio a text gratis | Fes-me l'acta!",
    description:
      "Transcriu àudio a text amb IA en català i altres idiomes. Puja MP3, WAV, M4A, FLAC, OGG o OPUS i obtén text amb timestamps sense registre obligatori.",
    keywords:
      'transcriure àudio a text, transcriure audio a text, transcripció audio, àudio a text gratis, Fes-me lacta',
    heading: 'Transcriure àudio a text',
    intro:
      'Converteix àudios llargs en text en minuts. Puja una reunió, entrevista, classe o podcast i revisa la transcripció amb timestamps.',
    ogImage: '/og/transcriure-audio-a-text.jpg',
    ogImageAlt: "Transcriure àudio a text | Fes-me l'acta!",
    kicker: 'Àudio a text amb IA',
    contentTitle: 'Transcriure àudio a text sense complicacions',
    contentIntro:
      "Fes-me l'acta! transforma fitxers MP3, WAV, M4A, FLAC, OGG o OPUS en text consultable. És útil per passar notes de veu, reunions, entrevistes i classes a un document que puguis copiar, revisar o resumir.",
    useCases: [
      {
        title: 'Notes de veu i gravacions',
        text: 'Passa àudio a text per trobar idees, cites i decisions sense escoltar-ho tot de nou.',
      },
      {
        title: 'Reunions i classes',
        text: 'Genera una base escrita per crear actes, resums i subtítols amb menys feina manual.',
      },
      {
        title: 'Podcasts i entrevistes',
        text: 'Converteix converses llargues en text editable per preparar articles, clips o documents.',
      },
    ],
    howItWorksTitle: 'Com passar àudio a text?',
    howItWorksText:
      "Puja el fitxer, tria l'idioma de l'àudio, selecciona el mode ràpid o qualitat i espera que aparegui la transcripció amb marques de temps.",
    resultTitle: 'Text editable i timestamps',
    resultText:
      'Quan acaba el procés, pots copiar el text o exportar subtítols SRT. Els timestamps ajuden a tornar al fragment exacte de la gravació.',
    privacyTitle: 'Privacitat de la gravació',
    privacyText:
      'El fitxer es fa servir per generar la transcripció. Abans de pujar àudios sensibles, revisa la política de privacitat i elimina dades que no siguin necessàries.',
    lastmod: '2026-07-03',
    changefreq: 'monthly',
    priority: 0.9,
  },
  {
    path: '/transcriure-audio-a-text-catala',
    primaryKeyword: 'transcriure àudio a text català',
    title: "Transcriure àudio a text en català gratis | Fes-me l'acta!",
    description:
      "Transcriu àudio a text en català amb IA. Puja reunions, entrevistes o classes i obtén una transcripció editable amb timestamps sense registre obligatori.",
    keywords:
      'transcriure àudio a text català, transcriure audio a text catala, transcriure audio a text català gratis, transcripció català',
    heading: 'Transcriure àudio a text en català',
    intro:
      'Puja un àudio en català i obtén una transcripció editable amb timestamps per revisar reunions, entrevistes, classes o podcasts.',
    ogImage: '/og/transcriure-audio-a-text-catala.jpg',
    ogImageAlt: "Transcriure àudio a text en català | Fes-me l'acta!",
    kicker: 'Transcripció en català',
    contentTitle: 'Transcriure àudio a text en català',
    contentIntro:
      "Fes-me l'acta! està pensat per convertir àudios en català en text útil per treballar. Accepta MP3, WAV, M4A, FLAC, OGG o OPUS i ajuda a preparar actes, resums i subtítols a partir de la transcripció.",
    useCases: [
      {
        title: 'Reunions en català',
        text: 'Extreu acords, tasques i cites textuals de converses de feina o entitats.',
      },
      {
        title: 'Classes i formació',
        text: 'Converteix sessions gravades en apunts revisables i fàcils de compartir.',
      },
      {
        title: 'Contingut en català',
        text: 'Prepara textos, fragments i subtítols a partir de podcasts, vídeos o entrevistes.',
      },
    ],
    howItWorksTitle: 'Com funciona?',
    howItWorksText:
      "Puja el fitxer, deixa l'idioma en català, escull el mode de processament i espera el text amb timestamps.",
    resultTitle: 'Resultat en text català',
    resultText:
      'La transcripció queda preparada per copiar, editar o exportar en SRT. La precisió millora amb veu clara, volum estable i poc soroll de fons.',
    privacyTitle: 'Privacitat dels àudios',
    privacyText:
      'Els fitxers es processen per generar el text. Revisa la política de privacitat abans de pujar gravacions amb informació sensible.',
    lastmod: '2026-07-03',
    changefreq: 'monthly',
    priority: 0.9,
  },
  {
    path: '/transcripcio-reunions-catala',
    primaryKeyword: 'transcripció reunions català',
    title: "Transcripció de reunions en català | Fes-me l'acta!",
    description:
      'Transcriu reunions en català i obtén un text amb timestamps per preparar actes, acords i resums. Funciona amb àudios llargs sense registre obligatori.',
    keywords:
      'transcripció reunions català, transcriure reunions català, actes de reunions, transcripció actes català',
    heading: 'Transcripció de reunions en català',
    intro:
      'Converteix reunions gravades en una transcripció clara per trobar acords, decisions i intervencions sense repassar tot l’àudio.',
    ogImage: '/og/transcripcio-reunions-catala.jpg',
    ogImageAlt: "Transcripció de reunions en català | Fes-me l'acta!",
    kicker: 'Reunions i actes',
    contentTitle: 'Transcripció de reunions en català per preparar actes',
    contentIntro:
      "Fes-me l'acta! ajuda a passar reunions en català a text perquè puguis extreure acords, tasques i punts oberts. Accepta formats com MP3, WAV, M4A, FLAC, OGG o OPUS i genera timestamps per saltar al moment exacte.",
    useCases: [
      {
        title: 'Actes de reunió',
        text: 'Fes servir la transcripció com a base per escriure actes més completes i verificables.',
      },
      {
        title: 'Acords i tasques',
        text: 'Busca decisions, responsables i terminis dins del text abans de compartir el resum.',
      },
      {
        title: 'Equips i entitats',
        text: 'Documenta converses de feina, assemblees o sessions internes en català.',
      },
    ],
    howItWorksTitle: 'Com transcriure una reunió?',
    howItWorksText:
      "Exporta o grava l'àudio, puja'l a la web, tria català i processa'l en mode ràpid o qualitat segons el temps disponible.",
    resultTitle: 'Text per revisar i resumir',
    resultText:
      'La transcripció no substitueix la revisió humana, però redueix molt la feina de preparar actes, resums i fragments citables.',
    privacyTitle: 'Reunions amb informació sensible',
    privacyText:
      'Abans de pujar una reunió amb dades sensibles, revisa la política de privacitat i comparteix només el que sigui necessari.',
    lastmod: '2026-07-03',
    changefreq: 'monthly',
    priority: 0.8,
  },
  {
    path: '/transcripcio-entrevistes-catala',
    primaryKeyword: 'transcripció entrevistes català',
    title: "Transcripció d'entrevistes en català | Fes-me l'acta!",
    description:
      'Transcriu entrevistes en català amb IA i treballa sobre un text editable amb timestamps. Ideal per recerca, periodisme, podcasts i contingut.',
    keywords:
      'transcripció entrevistes català, transcriure entrevistes català, entrevista a text, transcripció entrevistes',
    heading: "Transcripció d'entrevistes en català",
    intro:
      'Passa entrevistes llargues a text per trobar cites, ordenar idees i preparar articles, informes, episodis o materials de recerca.',
    ogImage: '/og/transcripcio-entrevistes-catala.jpg',
    ogImageAlt: "Transcripció d'entrevistes en català | Fes-me l'acta!",
    kicker: 'Entrevistes a text',
    contentTitle: "Transcripció d'entrevistes en català",
    contentIntro:
      "Fes-me l'acta! converteix entrevistes gravades en català en un text que pots llegir, cercar i editar. La transcripció amb timestamps facilita tornar al fragment d'àudio quan necessites validar una cita.",
    useCases: [
      {
        title: 'Recerca qualitativa',
        text: 'Treballa entrevistes llargues amb un text base per codificar temes i patrons.',
      },
      {
        title: 'Periodisme i contingut',
        text: 'Localitza declaracions, prepara articles i transforma converses en peces publicables.',
      },
      {
        title: 'Podcasts i vídeo',
        text: 'Crea resums, fragments socials i subtítols SRT a partir de la mateixa transcripció.',
      },
    ],
    howItWorksTitle: 'Com transcriure una entrevista?',
    howItWorksText:
      "Puja l'àudio de l'entrevista, selecciona català i escull el mode que millor encaixi amb la qualitat de la gravació.",
    resultTitle: 'Cites més fàcils de verificar',
    resultText:
      "Els timestamps ajuden a comprovar cada cita dins l'àudio original. La revisió final és important si el text s'ha de publicar.",
    privacyTitle: 'Consentiment i dades personals',
    privacyText:
      'Si una entrevista conté dades personals, assegura’t que tens permís per processar-la i revisa la política de privacitat.',
    lastmod: '2026-07-03',
    changefreq: 'monthly',
    priority: 0.8,
  },
  {
    path: '/subtitols-srt-catala',
    primaryKeyword: 'subtítols SRT català',
    title: "Subtítols SRT en català | Fes-me l'acta!",
    description:
      "Crea subtítols SRT en català a partir d'àudios o vídeos. Transcriu el contingut amb IA i exporta un fitxer SRT amb timestamps.",
    keywords:
      'subtítols SRT català, subtitols srt catala, crear subtítols català, transcripció subtítols català',
    heading: 'Crear subtítols SRT en català',
    intro:
      'Transcriu àudios o vídeos en català i exporta subtítols SRT amb timestamps per editar-los o publicar-los on els necessitis.',
    ogImage: '/og/subtitols-srt-catala.jpg',
    ogImageAlt: "Crear subtítols SRT en català | Fes-me l'acta!",
    kicker: 'Subtítols en català',
    contentTitle: 'Crear subtítols SRT en català a partir d’àudio',
    contentIntro:
      "Fes-me l'acta! genera una transcripció amb timestamps que pots exportar com a SRT. És una manera ràpida de preparar subtítols en català per vídeos, classes, entrevistes, podcasts o materials interns.",
    useCases: [
      {
        title: 'Vídeos i clips',
        text: 'Genera una primera versió de subtítols per revisar-la al teu editor de vídeo.',
      },
      {
        title: 'Classes i formació',
        text: 'Facilita que el contingut oral sigui més consultable i accessible.',
      },
      {
        title: 'Entrevistes i podcasts',
        text: 'Crea subtítols o transcripcions de suport per publicar fragments en català.',
      },
    ],
    howItWorksTitle: 'Com crear un SRT?',
    howItWorksText:
      "Puja l'àudio o vídeo, selecciona català, espera la transcripció amb timestamps i exporta el resultat en format SRT.",
    resultTitle: 'SRT revisable',
    resultText:
      'El fitxer SRT és una base per revisar temps, puntuació i noms propis abans de publicar el vídeo final.',
    privacyTitle: 'Privacitat del contingut',
    privacyText:
      'Els fitxers que puges es processen per generar transcripcions i subtítols. Consulta la política de privacitat abans de pujar material sensible.',
    lastmod: '2026-07-03',
    changefreq: 'monthly',
    priority: 0.75,
  },
];

module.exports = {
  SEO_LANDING_PAGES,
};
